/* The Ania Edit — launch theme interactions */
(function () {
  document.documentElement.classList.remove('no-js');

  /* Countdown — every [data-countdown] on the page ticks to the same launch moment */
  var pad = function (n) { return String(n).padStart(2, '0'); };
  var timers = Array.prototype.slice.call(document.querySelectorAll('[data-countdown]'));
  function tick() {
    var now = Date.now();
    timers.forEach(function (el) {
      var target = Date.parse(el.getAttribute('data-countdown'));
      if (isNaN(target)) return;
      var diff = Math.max(0, target - now);
      if (diff === 0) { el.classList.add('is-live'); return; }
      var s = Math.floor(diff / 1000);
      var parts = { days: Math.floor(s / 86400), hours: Math.floor(s % 86400 / 3600), minutes: Math.floor(s % 3600 / 60), seconds: s % 60 };
      Object.keys(parts).forEach(function (k) {
        var node = el.querySelector('[data-unit="' + k + '"]');
        var v = k === 'days' ? String(parts[k]).padStart(2, '0') : pad(parts[k]);
        if (node && node.textContent !== v) node.textContent = v;
      });
    });
  }
  if (timers.length) { tick(); setInterval(tick, 1000); }

  /* Scroll reveal */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (r) { io.observe(r); });
  } else { reveals.forEach(function (r) { r.classList.add('is-in'); }); }

  /* Header hairline on scroll */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* Sign-up: texture chips write into the customer tags so you can segment your list */
  document.querySelectorAll('[data-join-form]').forEach(function (form) {
    var tagsInput = form.querySelector('[data-tags]');
    var base = tagsInput ? tagsInput.value : '';
    function sync() {
      var picked = Array.prototype.map.call(form.querySelectorAll('[data-texture-chip]:checked'), function (c) { return 'texture-' + c.value; });
      if (tagsInput) tagsInput.value = [base].concat(picked).filter(Boolean).join(', ');
    }
    form.addEventListener('change', sync); sync();
  });

  /* "Notify me" on a texture card pre-selects that texture and scrolls to the sign-up */
  document.querySelectorAll('[data-notify]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var value = btn.getAttribute('data-notify');
      var chip = document.querySelector('[data-texture-chip][value="' + value + '"]');
      if (chip) { chip.checked = true; chip.dispatchEvent(new Event('change', { bubbles: true })); }
      var target = document.getElementById('join');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var email = target.querySelector('input[type="email"]');
        if (email) setTimeout(function () { email.focus({ preventScroll: true }); }, 700);
      }
    });
  });
})();
